import { css } from "lit";

export const scheduleCss = css`
    .calendar-container {
        width: 100%;
        height: 100%;
    }

    .calendar-lg-container {
        width: 100%;
        padding-left: 10px;
        display: flex;
        flex-flow: column;
    }

    .calendar-lg-container div:last-child {
        flex-grow: 1;
    }

    .calendar-lg-container ul {
        padding: 0;
        margin: 0;
        display: flex;
    }

    #calendar-view-container li.active {
        background: #fff;
    }
    #calendar-view-container li {
        cursor: pointer;
    }
    .calendar-lg-container > div {
        display: flex;
        justify-content: flex-end;
    }

    .calendar-lg-container li {
        list-style-type: none;
        padding: 6px 12px;
        align-items: center;
    }

    .calendar-disabled {
        border: 1px solid black;
        background-color: #fffacd;
        color: #fd080880;
        padding: 5px 12px;
        margin-right: auto;
    }

    .calendar-sm-nav div {
        padding: 6px 12px;
    }

    .calendar-container {
        display: flex;
        width: 100%;
        padding: 5px 10px;
    }

    .calendar-sm-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 10px;
        border-right: 1px solid #aaaaa8;
        max-width: 230px;
        padding: 0 10px 10px 0;
    }

    .holidays-button-tooltip {
        align-self: flex-end;
    }

    .calendar-time {
        display: inline-block;
        color: black;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
    }

    .calendar-sm-container__bottom {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .task-edited-warning {
        color: rgba(216, 45, 48, 1);
        font-size: 12px;
        background-color: rgba(255, 236, 240, 1);
        border: 1px solid rgba(216, 45, 48, 1);
        border-radius: 20px;
        padding: 10px;
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .task-edited-warning__close-button {
        border: none;
        background-color: transparent;
        width: 30px;
        height: 30px;
        cursor: pointer;
    }

    .calendar-activate {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .activation-lock {
        cursor: pointer;
    }

    .calendar-sm-wrapper {
        padding: 10px 10px;
        display: flex;
        gap: 10px;
        flex-direction: column;
        align-items: center;
        margin-bottom: auto;
    }

    .calendar-lg-nav,
    .calendar-sm-nav {
        padding: 8px;
        border-bottom: 1px solid #aaaaa8;
    }

    .creategroup-wrap .create-btn {
        padding-top: 2px;
        cursor: pointer;
        color: #1e90ff;
        padding: 5px 0;
        cursor: pointer;
    }

    .input-container input {
        border: 1px solid;
    }

    .group-dropdown-label {
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: space-between;
    }

    .controls {
        width: 100%;
        border: 1px solid #aaaaa8;
        padding: 8px;
        box-sizing: border-box;
    }

    .controls p {
        margin: 0;
        padding-bottom: 8px;
    }

    .controls-row {
        display: flex;
        gap: 4px;
    }

    .group-dropdown-label .icon-arrow {
        margin-left: 15px;
    }

    .dropdown-wrap.active {
        padding: 5px;
        background: #fff;
    }

    .dropdown-wrap.active .dropdown-list-wrap {
        padding: 5px 0;
        background: #fff;
        width: max-content;
        position: static;
    }

    .error-groups {
        font-size: 12px;
        color: red;
        max-width: 240px;
    }

    .dropdown-list li div {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .dropdown-list li {
        cursor: pointer;
    }

    .create-group-content {
        background: #f5f0f5;
        padding: 10px;
    }

    .groups-buttons-wrap {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
        padding-top: 10px;
    }

    .groups-btn {
        cursor: pointer;
        color: #fff;
        padding: 4px 14px;
        background: #4d6eaf;
        border-radius: 4px;
        font-size: 12px;
        line-height: 17px;
    }

    .calendar-header-container {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }

    .calendar-header-container .arrow svg {
        width: 12px;
        height: 12px;
    }
    .calendar-header-container .arrow.right svg {
        transform: rotate(180deg);
    }

    .calendar-main {
        flex-direction: column;
    }

    #calendars-block {
        padding: 0px 10px;
        height: 30px;
        border: 1px #475867 solid;
        width: 100%;
    }

    .schedule-option_disabled {
        background-color: #767676
    }

    .schedule-option_selected {
        background-color: #1E90FF
    }
`;
